// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"facd7b96","732":"21e87808"}[chunkId] + ".chunk.js";
};